import Vue from "@/main";

var graphicDotsine = null;
var graphicDotsineLine = null;
var selectPoint = null;
var dataPoint = null;
var lineEl = null;
var crossSectionPoint = null;
var crossSection = null;
var earthworkPoint = null;

// 添加绘制图层
const createLayer = () => {
  if (!graphicDotsine) {
    graphicDotsine = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(graphicDotsine);
  }
};

const clearLayer = () => {
  if (graphicDotsine) {
    graphicDotsine.clear();
    if (graphicDotsineLine) graphicDotsineLine.clear();
    Vue.$GLOBAL.map.removeLayer(graphicDotsine, true);
    lineEl = null;
    selectPoint = null;
    dataPoint = null;
    graphicDotsine = null;
    crossSectionPoint = null;
    crossSection = null;
  }
};

const createGraphic = () => {
  graphicDotsine
    .startDraw({
      type: "point",
      style: {
        label: {
          text: "",
          pixelOffsetY: -50,
          visibleDepth: false,
          font_size: 14,
        },

        pixelSize: 20,
        color: Vue.$GLOBAL.default_markIconColor,
        scaleByDistance_farValue: 0.8,
        scaleByDistance_far: 1000,
        scaleByDistance_near: 100,
        scaleByDistance: true,
        visibleDepth: false,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
      },
    })
    .then((res) => {
      selectPoint = res;
    });
  graphicDotsine.off();
};

const createStakeGraphic = (stake, slope, elevation, position) => {
  if (dataPoint) {
    graphicDotsine.removeGraphic(dataPoint);
    dataPoint = null;
  }
  const graphic = new mars3d.graphic.PointEntity({
    position,
    style: {
      label: {
        text: `对应桩号: ${stake}\n设计高程: ${elevation}\n纵坡坡率: ${slope}`,
        pixelOffsetY: -50,
        visibleDepth: false,
        font_size: 14,
      },

      pixelSize: 20,
      color: "#4ac2ff",
      scaleByDistance_farValue: 0.8,
      scaleByDistance_far: 1000,
      scaleByDistance_near: 100,
      scaleByDistance: true,
      visibleDepth: false,
      horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
    },
  });
  graphicDotsine.addGraphic(graphic);
  dataPoint = graphic;
  graphicDotsine.off();
};

const createLineEl = (positions) => {
  if (lineEl) {
    graphicDotsine.removeGraphic(lineEl);
    lineEl = null;
  }
  const graphic = new mars3d.graphic.PolylineEntity({
    positions,
    style: {
      width: 5,
      color: "#3388ff",
      clampToGround: true,
      visibleDepth: false,
    },
  });
  graphicDotsine.addGraphic(graphic);
  graphicDotsine.flyTo();
  lineEl = graphic;
  graphicDotsine.off();
};

const createCrossSectionPoint = () => {
  graphicDotsine
    .startDraw({
      type: "point",
      style: {
        label: {
          text: "",
          pixelOffsetY: -50,
          visibleDepth: false,
          font_size: 14,
        },
        pixelSize: 20,
        color: Vue.$GLOBAL.default_markIconColor,
        scaleByDistance_farValue: 0.8,
        scaleByDistance_far: 1000,
        scaleByDistance_near: 100,
        scaleByDistance: true,
        visibleDepth: false,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
      },
    })
    .then((res) => {
      crossSectionPoint = res;
    });
  graphicDotsine.off();
};

const createCrossSection = (positions, text) => {
  graphicDotsine.clear();
  if (graphicDotsineLine) graphicDotsineLine.clear();
  crossSection = null;
  const graphic = new mars3d.graphic.PolylineEntity({
    positions,
    style: {
      label: {
        text,
        visibleDepth: false,
      },
      outline: true,
      outlineColor: "#fff",
      outlineWidth: 5,
      width: 50,
      color: "#3388ff",
      clampToGround: true,
      visibleDepth: false,
    },
  });
  graphicDotsine.addGraphic(graphic);
  graphicDotsine.flyTo();
  crossSection = graphic;
  graphicDotsine.off();
};

// 绘制点
const createEarthworkPoint = (off = false) => {
  // this.createLayer();
  graphicDotsine
    .startDraw({
      type: "point",
      style: {
        label: {
          text: "",
          pixelOffsetY: -50,
          visibleDepth: false,
          font_size: 14,
        },
        pixelSize: 20,
        color: Vue.$GLOBAL.default_markIconColor,
        scaleByDistance_farValue: 0.8,
        scaleByDistance_far: 1000,
        scaleByDistance_near: 100,
        scaleByDistance: true,
        visibleDepth: false,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
      },
    })
    .then((res) => {
      earthworkPoint = res;
    });
  if (off) graphicDotsine.off();
};

// 绘制点 + 线
// create Earthwork Line
const createEarthworkLine = (arr) => {
  if (!graphicDotsineLine) {
    graphicDotsineLine = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(graphicDotsineLine);
  }
  let position = arr.map((item) => {
    let [x, y, z] = item;
    return Cesium.Cartesian3.fromDegrees(x, y, z);
  });

  let earthworkLine = new mars3d.graphic.PolylineEntity({
    positions: position,
    style: {
      width: 5,
      color: "#ff0000",
      // 动画线材质
      show: true,
      depthFail: true,
      depthFailColor: "#ff0000",
    },
  });
  graphicDotsineLine.addGraphic(earthworkLine);
};

export {
  graphicDotsine,
  graphicDotsineLine,
  selectPoint,
  dataPoint,
  createLayer,
  clearLayer,
  createGraphic,
  createStakeGraphic,
  createLineEl,
  createCrossSectionPoint,
  createCrossSection,
  createEarthworkPoint,
  createEarthworkLine,
};
